import React from 'react';
import { Section } from '@antonpodolsky/design-system/regions/section/section';
import { Grid } from '@antonpodolsky/design-system/layout/grid/grid';
import { Card } from '@antonpodolsky/design-system/data-display/card/card';
import { Text } from '@antonpodolsky/design-system/typography/text/text';
import { Link } from '@antonpodolsky/design-system/typography/link/link';

export const HomepageFeatureNotes = () => (
  <Section width="full">
    <Grid columns="fixed-2" gap="3xl">
      <Card title="Supported metadata formats" titleStyle="marked" spacious>
        EXIF, IPTC, XMP, C2PA.
      </Card>

      <Card title="C2PA" titleStyle="marked" spacious>
        <Text as="p">
          Exify verifies and displays{' '}
          <Link href="https://c2pa.org/" external>
            Content Credentials
          </Link>
          , helping you trace an image&apos;s origin and identify AI-generated
          images.
        </Text>
        <Text as="p">
          Learn more in the{' '}
          <Link href="/blog/introduction-to-c2pa">Introduction to C2PA</Link>{' '}
          blog post.
        </Text>
      </Card>

      <Card title="Location" titleStyle="marked" spacious>
        If geolocation data is available, the city and country are resolved
        using{' '}
        <Link href="https://www.openstreetmap.org/" external>
          OpenStreetMap
        </Link>{' '}
        and displayed with a link to Google Maps.
      </Card>

      <Card title="Image detection" titleStyle="marked" spacious>
        Exify bypasses common restrictions that limit interaction with images,
        allowing it to work predictably and reliably on any website, either by
        hovering over images or using the contextual menu.
      </Card>

      <Card title="Settings" titleStyle="marked" spacious>
        <Text as="p">
          The settings dialog lets you customize the overlay&apos;s content,
          position and size, toggle the EXIF overlay and C2PA badge on or off
          for specific sites, and view the image histogram.
        </Text>
        <Text as="p">
          Learn more in the{' '}
          <Link href="/blog/exify-settings-overview">
            Exify settings overview
          </Link>{' '}
          blog post.
        </Text>
      </Card>

      <Card title="Limitations" titleStyle="marked" spacious>
        <Text as="p">
          Exify can only display EXIF and C2PA metadata that is embedded within
          the image.
        </Text>
        <Text as="p">
          The availability of this data depends on the website, image hosting
          service, or image owner.
        </Text>
      </Card>

      <Card title="Privacy" titleStyle="marked" spacious>
        The Exify extension and exify.io website do not collect any data or
        usage statistics.
      </Card>

      <Card title="Permissions" titleStyle="marked" spacious>
        To read image metadata Exify requires the &quot;Access your data for all
        websites&quot; permission. Exify does not access any other data on the
        page.
      </Card>
    </Grid>
  </Section>
);
